import { send } from './send';
import { uuid } from './uuid';

/** 重试信息存储在 localStorage 中的 key 前缀 */
const KEY_PREFIX = 'xes-fe-log-sdk-retrying:';
/** 日志请求 body 前缀 */
const LOG_BODY_PREFIX = 'content=';
/** 最大重试次数 */
const MAX_RETRYING_TIMES = 3;

export function writeRequestToLocalStorage (options) {
  // TODO
  // FIXME localStorage 存满问题，过滤掉不重要的，例如 403，a.gif b.gif
  try {
    window.localStorage?.setItem(`${KEY_PREFIX}${options.retryingid}`, JSON.stringify(options));
  } catch (error) {
    console.warn(error)
  }
}

export function removeRequestFromLocalStorage (options) {
  try {
    window.localStorage?.removeItem(`${KEY_PREFIX}${options.retryingid}`);
  } catch (error) {
    console.warn(error)
  }
}

/**
 * 重试上报 localStorage 中的失败日志
 */
export function retryToLog () {
  for (let i = 0; i < window.localStorage?.length; i++) {
    const key = window.localStorage?.key(i);
    if (key.slice(0, KEY_PREFIX.length) === KEY_PREFIX) {
      try {
        const options = JSON.parse(window.localStorage.getItem(key));
        options.retryingTimes = options.retryingTimes + 1
        log(options);
      } catch (error) {
        console.warn(error);
        window.localStorage?.removeItem(key);
      }
    }
  }
}

/**
 * 发送日志，失败会重试
 * @param {object} options - send.ajax 请求参数 + 下列字段
 * @param {string} options.retryingid - 请求重试唯一标识
 * @param {number} options.retryingTimes - 请求重试次数
 * @param {number} options.retryingTimestamp - 请求重试时的客户端时间戳
 */
export function log (options) {
  options.retryingid = options.retryingid || uuid();
  options.retryingTimes = options.retryingTimes || 0;
  options.retryingTimestamp = Date.now();

  // 上报重试相关信息 retryingid retryingTimes retryingTimestamp
  try {
    const content = JSON.parse(options.data.slice(LOG_BODY_PREFIX.length));
    const contents = Array.isArray(content) ? content : [content];
    contents.forEach(c => {
      c.data.retryingid = options.retryingid;
      c.data.retryingTimes = options.retryingTimes;
      c.data.retryingTimestamp = options.retryingTimestamp;
    });
    options.data = `${LOG_BODY_PREFIX}${JSON.stringify(contents)}`
  } catch (error) {
    console.warn(error);
  }

  // 限制重试上报次数
  if (options.retryingTimes <= MAX_RETRYING_TIMES) {
    writeRequestToLocalStorage(options);
    send.ajax({
      ...options,
      success () { removeRequestFromLocalStorage(options) },
      fail () {
        options.retryingTimes = options.retryingTimes + 1
        log(options)
      }
    })
  } else {
    removeRequestFromLocalStorage(options);
  }
}
